import Swiper from 'swiper';

export const initializeLinkListSlider = (node) => {
  const teaserPromoSection = document.querySelector('.teaser-promo-section');

  return new Swiper(node, {
    slidesPerView: teaserPromoSection ? 3 : !!node.querySelector('.swiper-slide > img[alt*="https"]') ? 'auto' : 4,
    spaceBetween: teaserPromoSection ? 20 : 30,
    slidesPerGroup: teaserPromoSection ? 3 : 4,
    freeMode: true,
    paginationClickable: true,
    pagination: '.swiper-pagination',
    breakpoints: {
      // when window width is <= 767px
      767: {
        autoHeight: !teaserPromoSection || !!document.querySelector('#vehicle-recommended-products'),
        slidesPerView: 1.2,
        slidesPerGroup: 1,
      },
      990: !teaserPromoSection && {
        slidesPerView: 2.2,
        slidesPerGroup: 2,
      },
    },
    onInit: (swiper) => swiper.update(),
  });
};
